module.exports = __webpack_public_path__ + "img/music-work-icon7.8f664bbd.png";